<template>
  <div>
    <div class="bg-secondary-3 rounded p-3">
      <div class="color-dark-gray font-weight-bold font-16 mb-3">
        {{ title }}
      </div>
      <div class="row">
        <div
          class="col border-right d-flex flex-column justify-content-center align-items-center py-2"
        >
          <div class="color-gray font-14">{{ totalTitle }}</div>
          <div class="color-green font-34">{{ totalCount | currency }}</div>
        </div>
        <div
          class="col border-right d-flex flex-column justify-content-center align-items-center py-2"
        >
          <div class="color-gray font-14">{{ pendingTitle }}</div>
          <div class="color-dark-gray font-34">{{ pendingCount | currency }}</div>
        </div>
        <div
          class="col d-flex flex-column justify-content-center align-items-center py-2"
        >
          <div class="color-gray font-14">{{ completedTitle }}</div>
          <div class="color-dark-gray font-34">{{ completedPercentage }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "GeneralInfoSummary",
  props: {
    title: {
      type: String,
      require: true,
    },
    totalTitle: {
      type: String,
      default: () => "Total de Servicios",
    },
    pendingTitle: {
      type: String,
      default: () => "Servicios Pendientes",
    },
    completedTitle: {
      type: String,
      default: () => "Por ciento de Servicios Completados",
    },
    totalCount: {
      type: Number,
      default: () => 0,
    },
    pendingCount: {
      type: Number,
      default: () => 0,
    },
    completedCount: {
      type: Number,
      default: () => 0,
    },
  },
  computed: {
    completedPercentage() {
      return `${this.completedCount}%`;
    },
  },
};
</script>

<style scoped lang="scss"></style>
